import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { PrecheckinStep1Repository } from '../repository/precheckin-step1.repository';
import { ReservationPreChekin } from '../../reservation/models/reservation-response';

export class SavePrecheckinUseCase implements UseCase<any, any> {
    constructor(private readonly repository: PrecheckinStep1Repository) {}

    execute(reservation: ReservationPreChekin): Observable<any> {
        return this.repository.savePrecheckin(reservation);
    }
}
